import React, { Fragment, useMemo } from "react";
import { FieldListItem } from "@v2/components/PickerList/search/SearchModal/FieldListItem/FieldListItem";
import { useStyles } from "./SearchItemList.styles";

export interface IdGroup {
  label: string;
  ids: string[];
}

interface SearchItemListProps {
  searchValue: string;
  showOnlySelected: boolean;
  selectedIds: string[],
  items: any[];
  idGroups?: IdGroup[];
  onItemSelected: (itemId: string, selected: boolean) => void;
}

export const SearchItemList: React.FC<SearchItemListProps> = (props) => {
  const {items, selectedIds, showOnlySelected, searchValue, idGroups, onItemSelected} = props;
  const styles = useStyles();

  const itemsToShow = useMemo(() => {
    return searchValue || showOnlySelected
      ? items.filter((item: any) => {
        return (!searchValue || item.label.toLowerCase().includes(searchValue.toLowerCase())) &&
          (!showOnlySelected || selectedIds.includes(item.id))
      })
      : items;
  }, [searchValue, showOnlySelected, selectedIds, items]);

  const itemsMap = useMemo(() => {
    return itemsToShow.reduce<Map<string, any>>((map, item) => {
      map.set(item.id, item);
      return map;
    }, new Map());
  }, [itemsToShow]);

  return (
    <>
      {itemsToShow.length > 0 && (
        <div className={styles.scrollable}>
          {!!idGroups?.length && idGroups.map(idGroup => (
            <Fragment key={idGroup.label}>
              <div className={styles.groupHeader}>{idGroup.label}</div>
              {idGroup.ids
                .filter((itemId) => itemsMap.has(itemId))
                .map((itemId) => {
                  const item = itemsMap.get(itemId);
                  return (
                    <FieldListItem
                      key={item.id}
                      id={item.id}
                      label={item.label}
                      selected={selectedIds.includes(item.id)}
                      onChange={(selected) => onItemSelected(item.id, selected)}
                    />
                  )
                })
              }
            </Fragment>
          ))}
          {!idGroups?.length &&
            itemsToShow.map((item: any) =>
              <FieldListItem
                key={item.id}
                id={item.id}
                label={item.label}
                selected={selectedIds.includes(item.id)}
                onChange={(selected) => onItemSelected(item.id, selected)}
              />
            )
          }
        </div>
      )}
      {itemsToShow.length === 0 && (
        <>
          {!searchValue && showOnlySelected &&  (
            <div className={styles.noItemMessage}>
              No selected items to show
            </div>
          )}
          {searchValue &&  (
            <div className={styles.noItemMessage}>
              No items found
            </div>
          )}
        </>
      )}
    </>
  )
}
